import "./Utility/Translator/LanguageFile";
import "primereact/resources/themes/saga-blue/theme.css";
import './App.css';

import { Routes, Route } from "react-router-dom";
import Login from "./Pages/Login/Login";
import ForgotPasswordForm from "./Pages/Login/ForgotPasswordForm";
import AlarmsPage from "./Pages/AlarmsPage";
import DataPage from "./Pages/DataPage";
import ContinousDataPage from "./Pages/ContinousDataPage";
import EventPage from "./Pages/EventPage";
import RunningPage from "./Pages/RunningPage";
import EndProcessDataPage from "./Pages/EndProcessDataPage";
import CurvesDataPage from "./Pages/CurvesDataPage";
import ClientPlantChoicePage from "./Pages/Client-Plant Choice/ClientPlantChoicePage";
import { useEffect, useState } from "react";
import dbManagerInterface from "./Utility/DbConnection/DBManagerInterface";

export const isCloud = process.env.REACT_APP_IS_CLOUD === "true";

function App() {
  const [mainComponent, setMainComponent] = useState(<AlarmsPage />); // default fallback

  useEffect(() => {
    if(isCloud) return; // Skip if cloud
    const apiName = "Automata/GetStoreTypes";
    dbManagerInterface.SendGetRequest(
      apiName,
      (resData) => {
        if (resData.success && resData.data?.length > 0) {
          const storeTypes = resData.data;
          sessionStorage.setItem("availableStoreTypes", JSON.stringify(storeTypes));

          // ✅ Determine which page should be the main/default
          if (storeTypes.includes("STORE_ENDPROCESS")) {
            setMainComponent(<EndProcessDataPage />);
          } else if (storeTypes.includes("STORE_GRAPH")) {
            setMainComponent(<CurvesDataPage />);
          } else if (storeTypes.includes("STORE_ALARMS")) {
            setMainComponent(<AlarmsPage />);
          } else if (storeTypes.includes("STORE_REALTIME")) {
            setMainComponent(<ContinousDataPage />);
          } else if (storeTypes.includes("STORE_EVENT")) {
            setMainComponent(<EventPage />);
          } else if (storeTypes.includes("STORE_RUNNING")) {
            setMainComponent(<RunningPage />);
          } else {
            alert("No store types available for the selected client and plant");
          }
        } else {
          sessionStorage.setItem("availableStoreTypes", JSON.stringify([]));
          alert("No store types available for the selected client and plant");
        }
      },
      (error) => {
        console.error("Error fetching store types:", error);
        sessionStorage.setItem("availableStoreTypes", JSON.stringify([]));
        alert("Error fetching store types for the selected client and plant");
      }
    );
  }, []);

  return (
    <Routes>
      {/* if cloud → login page, else → main page (based on store types) */}
      {isCloud
        ? <Route path="/" element={<Login />} />
        : <Route path="/" element={mainComponent} />}
      
      <Route path="/clientPlantChoice" element={<ClientPlantChoicePage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgottenPassword" element={<ForgotPasswordForm />} />
      <Route path="/mainpage" element={mainComponent} />
      <Route path="/endprocess" element={<EndProcessDataPage />} />
      <Route path="/curves" element={<CurvesDataPage />} />
      <Route path="/alarms" element={<AlarmsPage />} />
      <Route path="/datapage" element={<DataPage />} />
      <Route path="/continousdata" element={<ContinousDataPage />} />
      <Route path="/events" element={<EventPage />} />
      <Route path="/running" element={<RunningPage />} />
    </Routes>
  );
}

export default App;
